import React from 'react';
import { LogoStyle } from './styles';
import { useIntl } from "gatsby-plugin-intl"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Logo = () => {
  const intl = useIntl();
  return (
    <StaticQuery
      query={graphql`
        query LogoQuery {
          file(relativePath: { eq: "praxis.png" }) {
            childImageSharp {
              # Specify the image processing specifications right in the query.
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          } 
        }
      `}
      render={data => (
    <LogoStyle>
      <Img
                  fluid={data.file.childImageSharp.fluid}
                  alt={intl.formatMessage({ id: "logoAlt" })}
                  title={intl.formatMessage({ id: "logoAlt" })} 
                />
    </LogoStyle>
      )}
      />
    )
  };

export default Logo;
